import styled, { css } from 'styled-components';
import { ApModal, colors } from '@alixpartners/ui-components';

export const StyledModal = styled(ApModal)`
	.ap-modal-wrapper {
		overflow: hidden;
	}

	.ap-modal-content {
		max-width: 640px;
		max-height: 100%;
	}

	.ap-modal-header {
		border: none;
		padding: 16px 16px 16px 32px;

		h4 {
			font-weight: 500;
			font-size: 23px;
			letter-spacing: 0.3px;
			padding-top: 16px;
		}

		.ap-button-icon {
			align-self: flex-start;
		}
	}

	.ap-modal-body {
		padding: 16px 32px 32px;
		line-height: 24px;
		display: flex;
		flex-direction: column;
	}

	.ap-modal-footer {
		padding: 8px 32px;
	}
`;

export const RadioGroup = styled.div`
	padding-top: 16px;
`;

export const RadioWrapper = styled.div`
	padding: 6px 0px;

	span + span {
		font-weight: normal;
		font-size: 16px;
		line-height: 24px;
		color: ${colors.grey8};
		padding-left: 16px !important;

		${({ disabled }) =>
			disabled &&
			css`
				color: ${colors.grey5};
				cursor: default;
			`};
	}
`;

export const Title = styled.div`
	font-size: 11px;
	line-height: 12px;
	color: ${colors.green2};
	padding: 16px 0 12px 0;

	&:first-child {
		padding-top: 0;
	}
`;

export const LoaderWrapper = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;
